import React, { useState, useEffect } from 'react';
import { PuzzlePieceIcon } from '@heroicons/react/24/outline';
import { NewGamePayload, DefaultService } from '../../../generated-api';
import { CompactEventRow } from './CompactEventRow';

interface NewGameCardProps {
  payload: NewGamePayload;
  createdAt: string;
}

export const NewGameCard: React.FC<NewGameCardProps> = ({ payload, createdAt }) => {
  const [gameImage, setGameImage] = useState<string | null>(payload.gameImage || null);

  // Fetch game image if not in payload
  useEffect(() => {
    if (!gameImage) {
      DefaultService.getGameGamesGameIdGet({ gameId: payload.gameId })
        .then(game => {
          if (game.imageUrl) setGameImage(game.imageUrl);
        })
        .catch(() => {
          // Image is not critical
        });
    }
  }, [payload.gameId, gameImage]);

  return (
    <CompactEventRow
      track="feed_new_game_card"
      to={`/games/${payload.gameId}`}
      icon={<PuzzlePieceIcon className="h-4 w-4" />}
      iconClassName="bg-purple-100 text-purple-600"
      label="New Game Added"
      createdAt={createdAt}
      thumbnail={gameImage && gameImage.trim() !== '' ? gameImage : null}
    >
      <span className="font-medium text-heading">{payload.gameName}</span>
      {' added to the library'}
    </CompactEventRow>
  );
};
